var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowUp = function SvgArrowUp(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_arrow_up",
    width: 12.049,
    height: 13.414,
    viewBox: "0 0 12.049 13.414",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42806",
    "data-name": "Path 42806",
    d: "M11160.6,759.12h-3.4l6.075-7.094,5.974,7.094h-3.547v2.866h-5.1Z",
    transform: "translate(-11157.202 -752.027)",
    fill: "#01ae3b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42807",
    "data-name": "Path 42807",
    d: "M0,0H5.1V.985H0Z",
    transform: "translate(3.411 10.952)",
    fill: "#01ae3b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_42808",
    "data-name": "Path 42808",
    d: "M0,0H5.1V.985H0Z",
    transform: "translate(3.411 12.43)",
    fill: "#01ae3b"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowUp, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbl9hcnJvd191cCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTIuMDQ5IiBoZWlnaHQ9IjEzLjQxNCIgdmlld0JveD0iMCAwIDEyLjA0OSAxMy40MTQiPgogIDxwYXRoIGlkPSJQYXRoXzQyODA2IiBkYXRhLW5hbWU9IlBhdGggNDI4MDYiIGQ9Ik0xMTE2MC42LDc1OS4xMmgtMy40bDYuMDc1LTcuMDk0LDUuOTc0LDcuMDk0aC0zLjU0N3YyLjg2NmgtNS4xWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMTU3LjIwMiAtNzUyLjAyNykiIGZpbGw9IiMwMWFlM2IiLz4KICA8cGF0aCBpZD0iUGF0aF80MjgwNyIgZGF0YS1uYW1lPSJQYXRoIDQyODA3IiBkPSJNMCwwSDUuMVYuOTg1SDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzLjQxMSAxMC45NTIpIiBmaWxsPSIjMDFhZTNiIi8+CiAgPHBhdGggaWQ9IlBhdGhfNDI4MDgiIGRhdGEtbmFtZT0iUGF0aCA0MjgwOCIgZD0iTTAsMEg1LjFWLjk4NUgwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy40MTEgMTIuNDMpIiBmaWxsPSIjMDFhZTNiIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };